import React from 'react';
import Header from '../common/Header';
import Footer from '../common/Footer';

const Layout = ({ children }) => {
  return (
    <>
      <main className="main" id="top">
        <Header />
        <div className="content">
          {children}
          <Footer />
        </div>
      </main>
    </>
  );
};

export default Layout;
